import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfgService } from '../../../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class ExpiringContractsCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class UnsignedContractsCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class ContractsKpiCfg {
  public expiringContracts: ExpiringContractsCfg;
  public unsignedContracts: UnsignedContractsCfg;
  public urlTalent: string;
}

@Injectable()
export class ContractsKpiCfgService extends CfgService<ContractsKpiCfg> {
  json: any = {
    expiringContracts: {
      summaryEndpointPattern: "%{DashboardApiUrl}/contracts/{0}/expiring?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardApiUrl}/contracts/{0}/expiring/detail?beginDate={1}&endDate={2}"
    },
    unsignedContracts: {
      summaryEndpointPattern: "%{DashboardApiUrl}/contracts/{0}/unsigned?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardApiUrl}/contracts/{0}/unsigned/detail?beginDate={1}&endDate={2}"
    },
    urlTalent: "%{TalentApiUrl}/#/"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/contractsKpi.cfg.json`;
  }

  /**
* Carga las url en el json
*/
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
